"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get InviteAcceptRequestSchema () {
        return InviteAcceptRequestSchema;
    },
    get InviteAcceptResponseSchema () {
        return InviteAcceptResponseSchema;
    }
});
const _zod = require("zod");
const InviteAcceptRequestSchema = _zod.z.object({
    token: _zod.z.string().min(1),
    password: _zod.z.string().min(12).max(256)
});
const InviteAcceptResponseSchema = _zod.z.object({
    userId: _zod.z.string().min(1)
});
